module.exports = __webpack_public_path__ + "static/media/0_2019_12_03.3eeca635.jpg";